import { useMemo } from 'react';

import { Error403Unauthorized } from '@app/components';
import { FORBIDDEN_ERROR_MAIN_PART } from '@app/constants';
import { useNewUserAccessRights } from '@app/hooks';
import type { ProductOperationType } from '@app/pages/Warehouses/WarehouseOperations/components/ProductOperation/types';
import {
  GoodsReceipt,
  GoodsWriteOff,
  GoodsTransfer,
} from '@app/pages/Warehouses/WarehouseOperations/components/ProductOperation/ui';

import '@pages/Warehouses/WarehouseOperations/components/ProductOperation/styles/ProductOperation.scss';

export const ProductOperation: ProductOperationType = ({ type }) => {
  const {
    userAccessRights: {
      Warehouse: {
        IsProductItemsAccept,
        IsProductItemsDecomission,
        IsProductItemsMove,
      },
    },
  } = useNewUserAccessRights();

  const isPageForbidden = useMemo(() => {
    switch (type) {
      case 'goods-receipt':
        return !IsProductItemsAccept;
      case 'goods-write-off':
        return !IsProductItemsDecomission;
      case 'goods-transfer':
        return !IsProductItemsMove;
      default:
        return false;
    }
  }, [
    type,
    IsProductItemsAccept,
    IsProductItemsDecomission,
    IsProductItemsMove,
  ]);

  const Content = useMemo(() => {
    switch (type) {
      case 'goods-receipt':
        return GoodsReceipt;
      case 'goods-write-off':
        return GoodsWriteOff;
      case 'goods-transfer':
        return GoodsTransfer;
      default:
        return () => null;
    }
  }, [type]);

  if (isPageForbidden) {
    return <Error403Unauthorized title={FORBIDDEN_ERROR_MAIN_PART} />;
  }

  return <Content />;
};
